import { Sparkles, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface GeneratePromptButtonProps {
  onClick: () => void;
  isGenerating: boolean;
  disabled?: boolean;
}

export function GeneratePromptButton({ onClick, isGenerating, disabled }: GeneratePromptButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
      disabled={disabled || isGenerating}
      className="w-full border-primary/30 text-primary hover:bg-primary/10 hover:border-primary/50 transition-all gap-2"
    >
      {isGenerating ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          Generating with AI...
        </>
      ) : (
        <>
          <Sparkles className="h-4 w-4" />
          Generate with AI
        </>
      )}
    </Button>
  );
}
